var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A202C",
    d: "M16 0c8.825 0 16 7.175 16 16s-7.175 16-16 16S0 24.825 0 16 7.175 0 16 0zm0 1.954C8.253 1.954 1.954 8.253 1.954 16c0 7.747 6.299 14.046 14.046 14.046 7.747 0 14.046-6.299 14.046-14.046 0-7.747-6.299-14.046-14.046-14.046zm6.864 9.406c.52-.48 1.285-.48 1.772 0 .485.482.485 1.272 0 1.752l-10.63 10.51c-.243.241-.555.378-.903.378-.347 0-.66-.138-.903-.378l-5.836-5.77c-.485-.482-.485-1.272 0-1.752.487-.48 1.286-.48 1.772 0l4.967 4.911z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2e0e8924.svg";
export { ForwardRef as ReactComponent };